import imagesLoaded from "imagesloaded";
import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(SplitText);

export default {
  init() {
    const body = document.body;
    const text = document.querySelector(".home-intro__body");
    if (!text) return;

    document.fonts.ready.then(() => {
      let split = SplitText.create(text, {
        type: "chars",
      });

      gsap.set(split.chars, { opacity: 0 });

      gsap.to(split.chars, {
        opacity: 1,
        duration: 0,
        stagger: 0.04,
        ease: "none",
      });
    });

    const MathUtils = {
      lerp: (a, b, n) => (1 - n) * a + n * b,
      distance: (x1, y1, x2, y2) => Math.hypot(x2 - x1, y2 - y1),
    };

    const getMousePos = (ev) => {
      let posx = 0;
      let posy = 0;
      if (!ev) ev = window.event;
      if (ev.pageX || ev.pageY) {
        posx = ev.pageX;
        posy = ev.pageY;
      } else if (ev.clientX || ev.clientY) {
        posx = ev.clientX + body.scrollLeft + docEl.scrollLeft;
        posy = ev.clientY + body.scrollTop + docEl.scrollTop;
      }
      return { x: posx, y: posy };
    };

    let mousePos = (lastMousePos = cacheMousePos = { x: 0, y: 0 });

    const introEl = document.querySelector(".home-intro");
    if (!introEl) return;

    introEl.addEventListener("mousemove", (ev) => (mousePos = getMousePos(ev)));

    const getMouseDistance = () =>
      MathUtils.distance(
        mousePos.x,
        mousePos.y,
        lastMousePos.x,
        lastMousePos.y
      );

    class Image {
      constructor(el) {
        this.DOM = { el: el };
        this.defaultStyle = {
          scale: 1,
          x: 0,
          y: 0,
          opacity: 0,
        };
        this.getRect();
        this.initEvents();
      }
      initEvents() {
        window.addEventListener("resize", () => this.resize());
      }
      resize() {
        gsap.set(this.DOM.el, this.defaultStyle);
        this.getRect();
      }
      getRect() {
        this.rect = this.DOM.el.getBoundingClientRect();
      }
      isActive() {
        return gsap.isTweening(this.DOM.el) || this.DOM.el.style.opacity != 0;
      }
    }

    class ImageTrail {
      constructor() {
        this.DOM = { content: document.querySelector(".home-intro__images") };
        this.images = [];
        [...this.DOM.content.querySelectorAll("img")].forEach((img) =>
          this.images.push(new Image(img))
        );
        this.imagesTotal = this.images.length;
        this.imgPosition = 0;
        this.zIndexVal = -1000;
        this.threshold = 100;
        requestAnimationFrame(() => this.render());
      }
      render() {
        let distance = getMouseDistance();
        cacheMousePos.x = MathUtils.lerp(
          cacheMousePos.x || mousePos.x,
          mousePos.x,
          0.1
        );
        cacheMousePos.y = MathUtils.lerp(
          cacheMousePos.y || mousePos.y,
          mousePos.y,
          0.1
        );

        if (distance > this.threshold) {
          this.showNextImage();

          ++this.zIndexVal;
          this.imgPosition =
            this.imgPosition < this.imagesTotal - 1 ? this.imgPosition + 1 : 0;

          lastMousePos = mousePos;
        }

        let isIdle = true;
        for (let img of this.images) {
          if (img.isActive()) {
            isIdle = false;
            break;
          }
        }
        if (isIdle && this.zIndexVal !== -1000) {
          this.zIndexVal = -1000;
        }

        requestAnimationFrame(() => this.render());
      }
      showNextImage() {
        const img = this.images[this.imgPosition];
        gsap.killTweensOf(img.DOM.el);

        gsap
          .timeline()
          .set(img.DOM.el, {
            opacity: 0,
            scale: 1,
            zIndex: this.zIndexVal,
            x: cacheMousePos.x - img.rect.width / 2,
            y: cacheMousePos.y - img.rect.height / 2,
          })
          .set(img.DOM.el, { opacity: 1 })
          .to(
            img.DOM.el,
            {
              duration: 0.9,
              ease: "expo.out",
              x: mousePos.x - img.rect.width / 2,
              y: mousePos.y - img.rect.height / 2,
            },
            0
          )
          .to(
            img.DOM.el,
            {
              duration: 1,
              ease: "power1.out",
              opacity: 0,
            },
            0.4
          )
          .to(
            img.DOM.el,
            {
              duration: 1,
              ease: "quint.out",
              scale: 0.2,
            },
            0.4
          );
      }
    }

    const preloadImages = () => {
      return new Promise((resolve, reject) => {
        imagesLoaded(
          document.querySelectorAll(".home-intro__images-item"),
          resolve
        );
      });
    };

    preloadImages().then(() => {
      document.body.classList.remove("loading");
      new ImageTrail();
    });
  },
};
